import MatestackUiVueJs from "matestack-ui-vuejs";
import { parseTime, formatTime, timeProblem } from "./time_entry";

// Typed time entry. The form value is always "HH:MM" (24-hour); the visible
// field shows and accepts the user's hour cycle. See TimeField.
const dsFormTimeInput = {
  mixins: [MatestackUiVueJs.componentMixin, MatestackUiVueJs.formInputMixin],
  template: MatestackUiVueJs.componentHelpers.inlineTemplate,
  data() {
    return {
      display: "", // what the text field shows
      invalidMessage: "",
    };
  },
  methods: {
    field() {
      return this.getTemplateElement().querySelector('[data-ds-time="text"]');
    },
    cycle() {
      return this.props["hour_cycle"] === "h12" ? "h12" : "h24";
    },
    // The form value for the current text ("" for blank, null for a bad entry).
    compose() {
      const text = this.display.trim();
      if (text === "") return { value: "", message: "" };
      const value = parseTime(text);
      return value ? { value, message: "" } : { value: "", message: timeProblem(this.cycle()) };
    },
    update(showMessage) {
      const key = this.props["key"];
      const { value, message } = this.compose();
      const field = this.field();
      if (field) field.setCustomValidity(message);
      if (showMessage || !message) this.invalidMessage = message;
      if (this.parentFormData[key] !== value) {
        this.parentFormData[key] = value;
        this.inputChanged(key);
      }
      if (this.emitted !== value) {
        this.emitted = value;
        this.getTemplateElement().dispatchEvent(
          new CustomEvent("ds:change", { bubbles: true, detail: { key, value } })
        );
      }
    },
    load(value) {
      this.display = formatTime(value, this.cycle());
      this.emitted = this.compose().value;
      this.invalidMessage = "";
      const field = this.field();
      if (field) field.setCustomValidity("");
    },
    afterInitialize(value) {
      this.load(value);
    },
    onText(event) {
      this.display = event.target.value;
      this.update(this.touched);
    },
    onBlur() {
      this.touched = true;
      const value = parseTime(this.display);
      if (value) this.display = formatTime(value, this.cycle());
      this.update(true);
    },
  },
  mounted() {
    // Plain instance fields, not data(): no reactivity wanted.
    this.touched = false;
    this.emitted = null;

    // Form `reset: true` and server rerenders change the form value from
    // outside; resync the field when it is not the value we wrote.
    this.stopWatching = this.$watch(
      () => this.parentFormData[this.props["key"]],
      (value) => {
        const current = value == null ? "" : value;
        if (current !== this.emitted) this.load(current);
      }
    );
  },
  beforeUnmount() {
    if (this.stopWatching) this.stopWatching();
  },
};

export default dsFormTimeInput;
